import React from "react";
import { FileText, Image as ImageIcon, Download } from "lucide-react";

const formatFileSize = (bytes) => {
  if (!bytes) return "";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(1))} ${units[i]}`;
};

const AttachmentsList = ({ attachments = [] }) => {
  if (!attachments.length) return null;

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-text_muted mb-2.5">Attachments</p>
      <div className="space-y-2">
        {attachments.map((file) => (
          <a
            key={file.id}
            href={file.file_url}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-3.5 py-2.5 rounded-xl border border-border"
          >
            <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-surface_alt flex items-center justify-center">
              {file.file_type?.startsWith("image/") ? (
                <ImageIcon size={15} className="text-primary" />
              ) : (
                <FileText size={15} className="text-danger" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[13px] font-medium text-text_primary truncate">{file.file_name}</p>
              <p className="text-[11px] text-text_muted">{formatFileSize(file.file_size)}</p>
            </div>
            <Download size={14} className="flex-shrink-0 text-text_muted" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default AttachmentsList;
